import { erpAxios } from '.';

const loanReleaseAnalytics = async (data) => {
  const res = await erpAxios.post(`/loanReleaseAnalytics/add`, data);
  return res;
};

export default loanReleaseAnalytics;
